var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgErrorWarn = function SvgErrorWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21.5L12 2.5L23 21.5H1ZM19.53 19.5L12 6.48999L4.46996 19.5H19.53ZM13 16.5H11V18.5H13V16.5ZM11 10.5H13V14.5H11V10.5Z",
    fill: "currentColor"
  })));
};

export { SvgErrorWarn as ReactComponent };
export default __webpack_public_path__ + "77055f3a33289ee0e8db891f86fbcfe5.svg";